export default __webpack_public_path__ + "static/services-banner-e58a6f2a5a2fedf488e46af7e0042cf4.jpg";